/*!
 * HaiKom Validation JavaScript Library.
 *
 * Copyright (C) HaiKom AB 2007-2017
 */
; (function (window, document, undefined) {
	'use strict';

	window.validateDatePickerValidDate = function (datePicker, calendar, input, validator, e) {
		var message;

		if (datePicker && calendar) {
			var messages = _getMessages(datePicker);
			var required = _getIsRequired(datePicker);

			var selectedDates = calendar.get_selectedDates();
			if (selectedDates instanceof Array &&
				selectedDates.length > 0) {
				var date = _getDate(selectedDates[0]);
				message = _validateDate(datePicker, calendar, input, date, messages);
			} else if (required) {
				message = 'Required';
			}
		}

		var hasMessage = message && message.length > 0;
		e.IsValid = !hasMessage;

		if (validator &&
			!e.IsValid &&
			hasMessage) {
			validator.errormessage = String.format(hk.message(message), e.Value);
			validator.innerHTML = validator.errormessage;
		}
	};

	function _validateDate(datePicker, calendar, input, date, messages) {
		var result;

		var dateValue = '';
		if(date) {
			if (date.isValid()) {
				date.setHours(0, 0, 0, 0);
				if (calendar) {
					var minDate = _getDate(calendar.get_rangeMinDate());
					var maxDate = _getDate(calendar.get_rangeMaxDate());
					var allowSelectWeekends = _getAllowSelectWeekends(datePicker);
					var allowSelectSpecialDates = _getAllowSelectSpecialDates(datePicker);

					if (minDate && date < minDate) {
						result = messages['too-early'];
					} else if (maxDate && date > maxDate) {
						result = messages['too-late'];
					} else if ((!allowSelectSpecialDates && _isSpecialDate(calendar, date)) ||
							   (!allowSelectWeekends && _isWeekend(date))) {
						result = messages['not-allowed'];
					}
				}
				dateValue = date.format(input.get_displayDateFormat());
			} else {
				result = messages['invalid-format'];
				dateValue = date.toString();
			}
		}

		if (typeof result === 'string' &&
			result.length > 0) {
			result = String.format(result, dateValue || '');
		}

		return result;
	}

	function _isWeekend(date) {
		return date instanceof Date && (date.getDay() === 0 || date.getDay() === 6);
	}

	function _isSpecialDate(calendar, date) {
		var result = false;

		if (calendar && date) {
			var specialDays = calendar.get_specialDaysArray();
			if (specialDays instanceof Array) {
				var specialDayDate;
				for (var i = 0; i < specialDays.length; i++) {
					specialDayDate = new Date(specialDays[i][1]);
					if (specialDayDate instanceof Date &&
						specialDayDate.getYear() === date.getYear() &&
						specialDayDate.getMonth() === date.getMonth() &&
						specialDayDate.getDate() === date.getDate()) {
						result = true;
						break;
					}
				}
			}
		}

		return result;
	}

	function _getDate(date) {
		var result;

		if (date) {
			if (date instanceof Array &&
				date.length > 2) {
				result = new Date(date[0], date[1] - 1, date[2]);
			} else if (date instanceof Date) {
				result = date;
			}
		}

		return result;
	}

	function _getMessages(datePicker) {
		var result = {};

		if (datePicker) {
			var validationMessagesAttribute = _getDataAttribute(datePicker, 'validation-messages');
			if (validationMessagesAttribute &&
					typeof validationMessagesAttribute === 'string') {
				result = validationMessagesAttribute.toJSON();
			}
		}

		return result;
	}

	function _getIsRequired(datePicker) {
		return _getBooleanDataAttribute(datePicker, 'validation-required', false);
	}

	function _getAllowSelectWeekends(datePicker) {
		return _getBooleanDataAttribute(datePicker, 'allow-select-weekends', true);
	}

	function _getAllowSelectSpecialDates(datePicker) {
		return _getBooleanDataAttribute(datePicker, 'allow-select-special-dates', true);
	}

	function _getBooleanDataAttribute(datePicker, attributeName, defaultValue) {
		var result = defaultValue;
		var attributeValue = _getDataAttribute(datePicker, attributeName);

		if (attributeValue &&
			typeof attributeValue === 'string' &&
			attributeValue.length > 0) {
			result = attributeValue.trim().toLowerCase() === 'true';
		}

		return result;
	}

	function _getDataAttribute(datePicker, attributeName) {
		var result;

		if (datePicker &&
			attributeName &&
			attributeName.length > 0) {
			result = datePicker.getAttribute('data-' + attributeName);
		}

		return result;
	}
})(window, document, undefined);
